import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useStyles } from "../../styles/SignDialog";
import CloseIcon from "@material-ui/icons/Close";
import { Tooltip } from '@material-ui/core';
import { DialogActions, IconButton } from "@material-ui/core";
import "../../styles/devices/mob_SignDialog.css";
import { withStyles } from "@mui/styles";
import { LinearProgress } from "@material-ui/core";
import VerifiedIcon from '@mui/icons-material/Verified';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import { Button } from "@mui/material";
import Card from "@mui/material/Card";
import { RankingSuccess6 } from "../../utils/icons";
import { Select, MenuItem } from '@mui/material';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';

export function CompareVideosDialogs(props) {
  const { openDialog, requested_video, selected_video, selected_label, speedCompareVideos, setSpeedCompareVideos, handleClickClose, btn_Send_Server, btn_Jump, showComparationVideos } = props;
  const styles = useStyles();
  const videoRef = useRef(null);
  const video2Ref = useRef(null);
  const counterRef = useRef(0);
  const [ showRef, setShowRef ] = useState(true);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    if (openDialog) {
      counterRef.current = 0;
      setShowRef(true);
      setVideoLoaded(false);
    }
    if (requested_video === null){
      handleClickClose();
    }

    if (videoRef.current && video2Ref.current) {
      videoRef.current.src = selected_video;
      video2Ref.current.src = requested_video;
    }

    console.log("openDialog", openDialog);
    console.log("openDialog - requested_video", requested_video);

  }, [openDialog]);

  const handleVideoEnded = () => {
    console.log("🚀 ~ file: CompareVideosDialogs.js:53 ~ handleVideoEnded ~ handleVideoEnded:", counterRef.current)
    counterRef.current += 1;
    if (counterRef.current % 2 === 0) {
      videoRef.current.play();
      setShowRef(true);
    }else{
      video2Ref.current.play();
      setShowRef(false);
    }
  };

  useEffect(() => {
    if (videoRef.current && video2Ref.current) {
      videoRef.current.src = selected_video;
      video2Ref.current.src = requested_video;
    }
  }, [selected_video, requested_video]);


  const handleChange = (event) => {
    setSpeedCompareVideos(event.target.value);
  };

  useEffect(() => {
    if (speedCompareVideos!==null && video2Ref.current && videoRef.current) {
      video2Ref.current.playbackRate = speedCompareVideos;
      videoRef.current.playbackRate = speedCompareVideos;
    }
  }, [speedCompareVideos]);

  const handleOnLoad = () => {
    console.log("handleOnLoad");
    video2Ref.current.playbackRate = speedCompareVideos;
    videoRef.current.playbackRate = speedCompareVideos;


    setVideoLoaded(true);
    videoRef.current.play()
  }


  return (
    <Dialog className="sig_SignModal_Dialog" open={openDialog} onClose={handleClickClose}>
        <DialogTitle>
            <span className="sig_VersusMachine_ResponseStatus_Success" style={{display:'flex', width: '85%', margin: 'auto'}}> <span style={{margin: 'auto', color: 'black', fontSize: '18px'}}>{selected_label}</span> </span>
            <IconButton aria-label="close" className="sig_Game_CloseButton" onClick={handleClickClose}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent className="sig_SignModal_DialogContent">
            {!videoLoaded && <LinearProgress className={styles.videoLoading} color="primary" />}
            <div>
              <video
                ref={videoRef}
                className={styles.signVideo}
                style={{
                  width: '50%',
                  ...((showRef === true) && { border: "5px solid red"})  
                }}
                autoPlay
                muted
                onLoadedData={handleOnLoad}
                onEnded={handleVideoEnded}
              >
                <source src={selected_video} type="video/mp4" />
              </video>
              <br/>

              <div style={{display: 'flex', margin: 'auto', width: '80%'}}>
                <span className="sig_VersusMachine_ResponseStatus_Failure" style={{display:'flex', width: '85%', margin: 'auto'}}>
                  <span style={{margin: 'auto', fontSize: '14px'}}>PENDIENTE DE ANOTAR</span>
                  <RankingSuccess6/>
                  <span style={{ marginLeft: '5px' }}>x{speedCompareVideos}</span>
                </span>
                <Select value={speedCompareVideos} onChange={handleChange} style={{ marginLeft: '10px' }}>
                  <MenuItem value={0.5}>0.5</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
              </Select>
              </div>

              {!videoLoaded && <LinearProgress className={styles.videoLoading} color="primary" />}

              <video
                ref={video2Ref}
                className={styles.signVideo}
                style={{
                  marginTop: '10px',
                  width: '50%',
                  ...((showRef === false) && { border: "5px solid red"})  
                }}
                muted
                onLoadedData={handleOnLoad}
                onEnded={handleVideoEnded}
              >
                <source src={requested_video} type="video/mp4" />
              </video>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>







            <Card style={{ display: 'flex', marginTop: '10px', backgroundColor: "white", padding: '10px', border: '3px solid #5ea0d4', justifyContent: 'center' }} className="sig_DataSet_CardContainer">
                <Tooltip 
                    classes={{tooltip: "sig_CustomTooltip_Container"}}
                    placement="down"
                    interactive={true} 
                    title={
                      <div className="sig_CustomTooltip_Content">
                        <p><strong>Confirmar.</strong></p>
                        {/* <p> El vídeo se corresponde con su anotación.</p> */}
                      </div>
                    }>
                    <IconButton onClick={btn_Send_Server}>
                      <VerifiedIcon fontSize="large" color='success'/>
                    </IconButton>
                </Tooltip>
                <Tooltip 
                    classes={{tooltip: "sig_CustomTooltip_Container"}}
                    placement="down"
                    interactive={true} 
                    title={
                      <div className="sig_CustomTooltip_Content">
                        <p><strong>No confirmo.</strong></p>
                        {/* <p> El vídeo no se corresponde con la anotación prevista o quiero aportar a mayores algún tipo de comentario.</p> */}
                      </div>
                    }>
                    <IconButton onClick={handleClickClose}>
                      <CancelPresentationIcon fontSize="large" color='error'/>
                    </IconButton>
                  </Tooltip>


                
                
            </Card>
            <Card style={{ display: 'flex', marginTop: '10px', backgroundColor: "white", padding: '10px', border: '2px solid #5ea0d4'}} className="sig_DataSet_CardContainer">

                  <Tooltip 
                    classes={{tooltip: "sig_CustomTooltip_Container"}}
                    placement="down"
                    interactive={true} 
                    title={
                      <div className="sig_CustomTooltip_Content">
                        <p><strong>Saltar.</strong></p>
                        {/* <p> Salto este vídeo y solicitó el siguiente.</p> */}
                      </div>
                    }>
                    <IconButton onClick={btn_Jump}>
                      <SkipNextIcon fontSize="large" color='warning'/>
                    </IconButton>
                  </Tooltip>
                
            </Card>
            <Card style={{ display: 'flex', marginTop: '10px', backgroundColor: "white", padding: '10px', border: '2px solid #5ea0d4'}} className="sig_DataSet_CardContainer">

                  <Tooltip 
                    classes={{tooltip: "sig_CustomTooltip_Container"}}
                    placement="down"
                    interactive={true} 
                    title={
                      <div className="sig_CustomTooltip_Content">
                        <p><strong>Pausar</strong></p>
                        {/* <p> Detener mecanismo express.</p> */}
                      </div>
                    }>
                    <IconButton onClick={showComparationVideos}>
                      <PauseCircleOutlineIcon fontSize="large" color='info'/>
                    </IconButton>
                  </Tooltip>
                
            </Card>
          </div>





          
             
            {/* <Button className="sig_DataSet_ButtonConfirm" variant="outlined" color="success" onClick={btn_Send_Server}>
                Confirmar
            </Button> */}
        </DialogContent>

        {/* <DialogActions>
          <IconButton>
              <VerifiedIcon/>
            </IconButton>
          <IconButton>
            <CancelPresentationIcon/>
          </IconButton>

        </DialogActions> */}
        
    </Dialog>
  );
}